/**
 * Manage payments data
 */
import Ajax from '@/lib/ajax_wrapper'

function paymentMethodsPath(companyId) {
  return `/companies/${companyId}/payments/payment_methods`
}

/**
 * List a Stripe customers payment methods
 *
 * @returns {promise}
 */
export function readCustomerPaymentMethodsData(companyId) {
  return Ajax.request({
    url: `${paymentMethodsPath(companyId)}`,
    method: 'GET'
  })
}

/**
 * Attach a payment method to a Stripe customer
 *
 * @returns {promise}
 */
export function attachCustomerPaymentMethodData(companyId, data) {
  return Ajax.request({
    url: `${paymentMethodsPath(companyId)}/attach`,
    data: data,
    method: 'POST'
  })
}

/**
 * Set a payment method as default for a Stripe customer
 *
 * @returns {promise}
 */
export function setDefaultCustomerPaymentMethod(companyId, data) {
  return Ajax.request({
    url: `${paymentMethodsPath(companyId)}/default`,
    data: data,
    method: 'PUT'
  })
}
